// extracted by mini-css-extract-plugin
export var container = "_rp-0";
export var dotAnimation = "_rp-2";
export var dotsLoading = "_rp-1";